<div class="container">
  <div class="container__pointer"></div>
  <div #content class="container__content">
    <ng-content></ng-content>
  </div>
</div>
